var map = {
	"./addonpayments.png": 78883,
	"./adyen.png": 86477,
	"./mercadopago.png": 28208,
	"./montevideocomm.png": 59214,
	"./paycomet.png": 71296,
	"./planet.png": 21068,
	"./redsys.png": 54014,
	"./sipay.png": 62762,
	"./stripe.png": 58853,
	"./trustpayments.png": 54723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64097;